
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './auth/auth.component';
import { PublicComponent } from './public/public.component';
import { TutorPanelComponent } from './tutor-panel/tutor-panel.component';
import { VisualizadorComponent } from './modules/visualizador/visualizador.component';
import { AuthGuardService } from './services/auth-guard.service';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'active-directory',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'active-directory',
        loadChildren: './auth/active-directory/active-directory.module#ActiveDirectoryModule'
      },
      {
        path: 'login',
        loadChildren: './auth/login/login.module#LoginModule'
      },
      {
        path: 'recovery',
        loadChildren: './auth/recovery/recovery.module#RecoveryModule'
      }
    ]
  },
  {
    path: '',
    component: VisualizadorComponent,
    canActivate: [AuthGuardService],
    children: [{
      path: 'visualizador',
      loadChildren: './modules/visualizador/visualizador.module#VisualizadorModule'
    }]
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    component: PublicComponent,
    children: [
      {
        path: 'home',
        loadChildren: './public/home/home.module#HomeModule'
      },
      {
        path: 'training',
        loadChildren: './public/training/training.module#TrainingModule'
      },
      {
        path: 'development',
        loadChildren: './public/development/development.module#DevelopmentModule'
      },
      {
        path: 'influencers',
        loadChildren: './public/influencers/influencers.module#InfluencersModule'
      },
      {
        path: 'videos',
        loadChildren: './public/videos/videos.module#VideosModule'
      },
      {
        path: 'articles',
        loadChildren: './public/articles/articles.module#ArticlesModule'
      },
      {
        path: 'forum',
        loadChildren: './public/forum/forum.module#ForumModule'
      },
      {
        path: 'my-page',
        loadChildren: './public/my-page/my-page.module#MyPageModule'
      },
      {
        path: 'my-page-unit',
        loadChildren: './public/unit-leader/unit-leader.module#UnitLeaderModule'
      },
      {
        path: 'notice',
        loadChildren: './public/notice/notice.module#NoticeModule'
      },
      {
        path: 'welcome',
        loadChildren: './public/welcome/welcome.module#WelcomeModule'
      },
      {
        path: 'search',
        loadChildren: './public/search/search.module#SearchModule'
      },
      {
        path: 'technical',
        loadChildren: './public/technical/technical.module#TechnicalModule'
      },
      {
        path: 'ecosystem',
        loadChildren: './public/technical/technical.module#TechnicalModule'
      },
      {
        path: 'clients-plus',
        loadChildren: './public/technical/technical.module#TechnicalModule'
      },
      {
        path: 'contribuitors',
        loadChildren: './public/contributors/contributors.module#ContributorsModule'
      },
      {
        path: 'notifications',
        loadChildren: './public/notifications/notifications.module#NotificationsModule'
      },
      {
        path: 'helpdesk',
        loadChildren: './public/helpdesk/helpdesk.module#HelpdeskModule'
      }
    ]
  },
  {
    path: '',
    component: TutorPanelComponent,
    children: [
      {
        path: 'tutor',
        loadChildren: './tutor-panel/courses/tutor-panel-courses.module#TutorPanelCoursesModule'
      },
      {
        path: 'tutor/classes/:id',
        loadChildren: './tutor-panel/classes/tutor-panel-classes.module#TutorPanelClassesModule'
      },
      {
        path: 'tutor/subscribers/:id',
        loadChildren: './tutor-panel/subscribers/tutor-panel-subscribers.module#TutorPanelSubscribersModule'
      }
    ]
  },

];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts